import React from 'react'

import AuthService from '../app/service/authService'
import StorageService from '../app/service/storageService'
export const AuthContext = React.createContext()
export const AuthConsumer = AuthContext.Consumer;

const AuthProvider = AuthContext.Provider;

class authenticationProvider extends React.Component {

    state = {
        userAuthenticated: null,
    }

    startSession = (response) => {
        AuthService.enter(response);
        this.setState({ userAuthenticated: response })
    }

    endSession = () => {
        StorageService.removeItem('everlink_user');
        StorageService.removeItem('everlink_type');
        StorageService.removeItem('subMenuOpen');
        StorageService.removeItem('plateName');
        AuthService.removeUserAuthenticated();
        this.setState({ userAuthenticated: null })
    }

    verifyAuth = (statusError) => {
        if (statusError === 401) {
            this.endSession();
            window.location.href = '/login';
        }
    }

    render() {
        const context = {
            startSession: this.startSession,
            endSession: this.endSession,
            userAuthenticated: this.state.userAuthenticated,
            userType: StorageService.getItem('everlink_type') !== null && StorageService.getItem('everlink_type'),
            isAuthenticated: StorageService.getItem('everlink_user') !== null ? true : false
        }

        return (
            <AuthProvider value={context} >
                {this.props.children}
            </AuthProvider>
        )
    }
}

export default authenticationProvider;